"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.VideoProvider = exports.useVideo = exports.VideoContext = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var react_2 = require("@xstate/react");
var video_machine_1 = require("../machines/video-machine");
var actions_1 = require("../actions");
exports.VideoContext = (0, react_1.createContext)({});
var useVideo = function () {
    var videoService = React.useContext(exports.VideoContext).videoService;
    return videoService;
};
exports.useVideo = useVideo;
/**
 * This is where the magic happens for the video player. The `videoService` is
 * the running xstate machine that we can use to interact with our global state
 * and the shared context of the video player.
 *
 * TODO: allow some actions to be passed in here
 *
 * @param props
 * @constructor
 *
 * @see {@link https://dev.to/mpocock1/how-to-manage-global-state-with-xstate-and-react-3if5}
 */
var VideoProvider = function (_a) {
    var _b = _a.actions, actions = _b === void 0 ? {} : _b, _c = _a.services, services = _c === void 0 ? {
        loadResource: function () { },
        loadViewer: function () { }
    } : _c, _d = _a.guards, guards = _d === void 0 ? {} : _d, children = _a.children;
    var videoService = (0, react_2.useInterpret)(video_machine_1.videoMachine, {
        actions: __assign(__assign({}, actions_1.defaultActions), actions),
        services: services,
        guards: guards
    });
    // see all state changes
    // videoService.onTransition((state) => {
    //   console.debug(state.value)
    // })
    return (React.createElement(exports.VideoContext.Provider, { value: { videoService: videoService } }, children));
};
exports.VideoProvider = VideoProvider;
